export default {
  feeDiscounts: {
    off: 'Off',
    tier: 'Tier',
    maker: 'Maker',
    taker: 'Taker',
    myFeeTier: 'My Fee Tier',
    currentApr: 'Current APR',
    pageTitle: 'Fee Discounts',
    updateDaily: 'Update daily',
    stakedAmount: 'Staked Amount',
    tradingVolume: 'Trading Volume',
    myStakedAmount: 'Staked Amount',
    lastUpdatedAt: 'Last updated at',
    inPastDays: 'In past {days} days',
    myTradingVolume: 'My Trading Volume',
    viewFeeDiscounts: 'View Fee Discounts',
    feesTakerMaker: 'Fees (Taker / Maker)',
    makerRateDiscount: 'Maker Rate Discount',
    takerRateDiscount: 'Taker Rate Discount',
    feesTakerMakerPercent: '{takerFee}% / {makerFee}%',
    makerRateDiscountTooltip: 'Maker fee discount based on the fee tier.',
    takerRateDiscountTooltip: 'Taker fee discount based on the fee tier.',
    pageDescriptionWarning:
      'Please note that the maker fee discounts are only applicable to markets with a non-negative maker fee.',
    pageDescription:
      "Trading fees are based on a user's staked amount of INJ and the total trading volume in the past 28 days.",
    tradingVolumeTooltip:
      'The total volume traded on a 28-day rolling basis. Only markets in USD quote denoms are included at this moment.',
    stakedAmountTooltip:
      'The amount of INJ required to be staked. Staking INJ secures the protocol, earns rewards and can help obtain a more preferable fee tier.'
  }
}
